import Aerator from './Aerator';
import Belt from './Belt';
import Bin from './Bin';
import Boot from './Boot';
import Scale from './Scale';
import Switch from './Switch';
import Pump from './Pump';
import Vibrator from './Vibrator';
import Screw from './Screw';
import Tank from './Tank';
import Horn from './Horn';
import AnalogInput from './AnalogInput';
import AnalogSwitch from './AnalogSwitch';
import DustCollector from './DustCollector';
import Mixer from './Mixer';
import TruckDevice from './Truck';
import SlumpMeter from './SlumpMeter';
import Diverter from './Diverter';
import RemoteDisplay from './RemoteDisplay';
import ManualPanel from './ManualPanel';
import Scoreboard from './Scoreboard';
import './DeviceAsDom.css';

export default {
  Aerator,
  Belt,
  Bin,
  Boot,
  Scale,
  Switch,
  Screw,
  Pump,
  Vibrator,
  Tank,
  AnalogInput,
  AnalogSwitch,
  Scoreboard,
  SlumpMeter,
  Horn,
  DustCollector,
  Mixer,
  TruckDevice,
  Diverter,
  RemoteDisplay,
  ManualPanel,
};
